module.exports = __webpack_public_path__ + "static/media/Althar_02.4849c332.png";